import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

import '../../scss/main.scss';
import ThemeReports from './components/ThemeReports.jsx';

ReactDOM.render(
  <ThemeReports />,
  document.getElementById('theme-reports-app'),
);
